import { keys } from '@core/Services/Analytics/keys'
import { trackKey } from '@core/Services/Analytics/track'

export const trackGiddyUpOpen = () => trackKey(keys.giddyUpOpen)
export const trackGiddyUpClosed = () => trackKey(keys.giddyUpClosed)
export const trackGiddyUpShowSpeedMap = () => trackKey(keys.giddyUpShowSpeedMap)
export const trackGiddyUpShowAllRating = () => trackKey(keys.giddyUpShowAllRating)
export const trackGiddyUpShowTopRating = () => trackKey(keys.giddyUpShowTopRating)
export const trackGiddyUpShowQuaddieTips = () => trackKey(keys.giddyUpShowQuaddieTips)
